<template>
  <div v-loading="loadingDocument" style="min-height: 100px;">
    <div
      class="p-document-content-wrap"
      v-for="(item,index) in recentlyDocumentData"
      :key="index"
      @click="goDocumentDetail(item)"
    >
      <div class="p-icon ibass ibass-dot"></div>
      <div class="p-document-content">
        <div class="p-document-title">
          <i
            class="p-document-icon ibass"
            v-if="item.name"
            :class="[item.className]"
            :style="{
              color: item.color
            }"
          />
          <div class="p-document-name" :title="item.name">{{item.name}}</div>
        </div>

        <div class="p-document-info">
          <span class="p-document-time text">{{item.mtime}}</span>
          <span class="p-document-size text">{{item.size}}</span>
        </div>
      </div>
    </div>
    <div class="blankText" v-if="showDocumentText">暂无最近浏览文档</div>
  </div>
</template>

<script>
import indexService from '../../../service/index'
import timeUtils from '@/utils/time'
import filePreview from '@/utils/preview'
export default {
  name: 'RecentlyDocument',
  data () {
    return {
      loadingDocument: false,
      showDocumentText: false,
      recentlyDocumentData: [],
      fileProps: {
        'docx': {
          icon: 'ibass-filetype-doc',
          color: '#0a96e5'
        },
        'doc': {
          icon: 'ibass-filetype-doc',
          color: '#0a96e5'
        },
        'pdf': {
          icon: 'ibass-filetype-pdf',
          color: '#e3574d'
        },
        'xlsx': {
          icon: 'ibass-filetype-excel',
          color: '#1c7044'
        },
        'pptx': {
          icon: 'ibass-filetype-ppt',
          color: '#e3574d'
        },
        'key': {
          icon: 'ibass-keynote',
          color: '#1a9bf7'
        },
        'numbers': {
          icon: 'ibass-numbers',
          color: '#08ad00'
        },
        'pages': {
          icon: 'ibass-pages',
          color: '#ff8403'
        },
        'default': {
          icon: 'ibass-filetype-default',
          color: '#cdc9c5'
        }
      }
    }
  },
  mounted () {
    this.getRecentlyDocument()
  },
  methods: {
    goDocumentDetail (item) {
      // let params = {
      //   commitId: '',
      //   fileName: item.name,
      //   filePath: item.filePath,
      //   repo: item.repo
      // }
      // this.getDocumentPreview(params)
      let params = {
        fileId: item.objectId,
        matterId: '',
        id: item.id,
        repoId: item.repo,
        filePath: (item.path || '') + '/' + item.name,
        name: item.name,
        size: item.size,
        className: filePreview.queryDocumentType(item.name)
      }
      filePreview.preview(params)
      this.$analysis.track('查看最近浏览文档_最近浏览/工作台模块')
    },
    async getDocumentPreview (params) {
      this.loading = true
      try {
        const response = await indexService.getDocumentPreview(params)
        if (response.isSuccess) {
          window.open(response.data.pdfUrl)
        } else {
          this.$postMessage.toast({ msg: '文档预览失败' })
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    handleFileSize (bytes) {
      if (bytes === 0 || bytes === '0') return '0 B'
      if (!bytes) return ''
      let k = 1024
      let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      let i = Math.floor(Math.log(bytes) / Math.log(k))
      return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
    },
    async getRecentlyDocument () {
      this.loadingDocument = true
      try {
        const response = await indexService.getRecentlyDocument()
        if (response.isSuccess) {
          if (response.data && response.data.length > 0) {
            this.recentlyDocumentData = response.data.map(item => {
              if (item.mtime) {
                item.mtime = timeUtils.formatTime(new Date(item.mtime * 1000), 'daytime')
              }
              if (item.size) {
                item.size = this.handleFileSize(item.size)
              }
              let type = item.name ? item.name.split('.').pop() : 'default'
              item.className = this.fileProps[type] ? this.fileProps[type].icon : this.fileProps.default.icon
              item.color = this.fileProps[type] ? this.fileProps[type].color : this.fileProps.default.color
              return item
            })
            this.showDocumentText = false
          } else {
            this.showDocumentText = true
          }
          this.loadingDocument = false
        } else {
          this.$postMessage.toast({ msg: response.message || response.resultMsg })
          this.loadingDocument = false
        }
      } catch (e) {
        this.loadingDocument = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .p-document-content-wrap {
    width 100%;
    display flex;
    .p-icon {
      color #C4C4C4;
      /*padding-top 3px;*/
    }
    .p-document-content {
      width calc(100% - 30px)
      margin-left 14px;
      box-sizing border-box;
      padding-bottom 14px;
      border-bottom 1px solid #f1f2f3;
      margin-bottom 10px;
      .p-document-title {
        width calc(100% - 30px)
        display flex
        .p-document-icon {
          width 14px;
          height 15px;
        }
        .p-document-name {
          font-size 14px;
          height 20px;
          line-height 20px;
          margin-left 4px;
          color #000000;
          margin-bottom 8px;
          text-overflow ellipsis;
          white-space nowrap;
          overflow hidden;
          cursor pointer;
        }
      }
      .p-document-info {
        .text {
          font-size 12px;
          color #8590A6;
        }
        .p-document-time {
          margin-right 5px;
        }
      }
    }
  }

  .blankText {
    font-size 14px;
    text-align center;
    margin-top 30px;
    color #8c939d;
  }
</style>
